import { defineMessages } from 'react-intl';

export const messages: {
	createSpace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewSpace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createSpace: {
		id: 'jsm-solution-composer-plan.task-card.card-footer.create-space',
		defaultMessage: 'Create space',
		description: 'Button text for creating a JSM service management space from the plan',
	},
	viewSpace: {
		id: 'jsm-solution-composer-plan.task-card.card-footer.view-space',
		defaultMessage: 'View space',
		description: 'Button text for viewing a JSM service management space from the plan',
	},
});
